import { render } from "./EventXMLModal.vue?vue&type=template&id=5d7665c6&scoped=true"
import script from "./EventXMLModal.vue?vue&type=script&lang=js"
export * from "./EventXMLModal.vue?vue&type=script&lang=js"

import "./EventXMLModal.vue?vue&type=style&index=0&id=5d7665c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7665c6"]])

export default __exports__